// Generated file - do not change manually!

/**
 * Different types of Button.
 */
export enum ButtonDesign {
  /**
   * attention type
   */
  Attention = 'Attention',

  /**
   * default type (no special styling)
   */
  Default = 'Default',

  /**
   * emphasized type
   */
  Emphasized = 'Emphasized',

  /**
   * reject style (red button)
   */
  Negative = 'Negative',

  /**
   * accept type (green button)
   */
  Positive = 'Positive',

  /**
   * transparent type
   */
  Transparent = 'Transparent'
}
